import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { nav } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Availability pill */}
      <div className="flex justify-center pt-0">
        <div className="bg-[#0b0b0b] text-white text-[13px] font-medium px-5 py-1.5 rounded-b-2xl flex items-center gap-2 shadow-lg">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
          {nav.status}
        </div>
      </div>

      {/* Nav bar */}
      <motion.nav
        initial={false}
        animate={{
          backgroundColor: scrolled ? "rgba(236,236,236,0.75)" : "rgba(236,236,236,0)",
          backdropFilter: scrolled ? "blur(12px)" : "blur(0px)",
        }}
        transition={{ duration: 0.3 }}
        className="px-5 md:px-10"
      >
        <div className="max-w-[1240px] mx-auto flex items-center justify-between py-4">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="font-cal text-[26px] text-[#ff4d17] leading-none"
          >
            {nav.logo}
          </button>

          <div className="hidden md:flex items-center gap-9 absolute left-1/2 -translate-x-1/2">
            {nav.links.map((l) => (
              <button
                key={l.label}
                onClick={() => scrollTo(l.href)}
                className="text-[15px] text-[#141414] hover:text-[#ff4d17] transition-colors"
              >
                {l.label}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => scrollTo(nav.cta.href)}
              className="hidden md:inline-flex bg-[#1c1c1c] text-white text-[15px] px-6 py-2.5 rounded-full hover:bg-[#ff4d17] transition-colors"
            >
              {nav.cta.label}
            </button>
            <button className="md:hidden text-[#141414]" onClick={() => setOpen(!open)}>
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              className="md:hidden overflow-hidden"
            >
              <div className="flex flex-col gap-4 pb-6 pt-2">
                {nav.links.map((l) => (
                  <button
                    key={l.label}
                    onClick={() => scrollTo(l.href)}
                    className="text-left text-lg text-[#141414]"
                  >
                    {l.label}
                  </button>
                ))}
                <button
                  onClick={() => scrollTo(nav.cta.href)}
                  className="bg-[#1c1c1c] text-white text-center py-3 rounded-full"
                >
                  {nav.cta.label}
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.nav>
    </div>
  );
};

export default Navbar;
